module.exports = __webpack_public_path__ + "static/media/values-background.a36cc9e2.jpg";